// extracted by mini-css-extract-plugin
module.exports = {"card":"_1t-XG"};